module.exports = require('react/lib/ReactFragment').create;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-create-fragment/index.js
 ** module id = 445
 ** module chunks = 0
 **/